/**
 * @typedef {{}} Props
 * @typedef {import('./State').default} State
 */

import { translate } from '../../Internationalization';
import BlogsWidget from './Blogs/BlogsWidget';
import React from 'react';
import Tabs from '../../shared/Tabs/Tabs';
import Valuation from './Valuation';

/** @extends {React.Component<Props, State>} */
export class ViewWidgets extends React.Component {
	/**
	 * @param {Props} props
	 */
	constructor(props) {
		super(props);

		/**
		 * @type {State}
		 */
		this.state = {
			activeTab: 'valuation',
		};
	}

	/** @returns {JSX.Element} */
	#renderWidget() {
		if (this.state.activeTab === 'valuation') {
			return <Valuation />;
		}

		return <BlogsWidget />;
	}

	/** @returns {JSX.Element} */
	#renderTabs() {
		return (
			<ul className="tabs">
				{['valuation', 'blog'].map((tab) => (
					<Tabs
						className={`tab ${
							this.state.activeTab === tab ? 'tab-active' : ''
						}`}
						key={tab}
						// @ts-ignore
						onClick={() => this.setState({ activeTab: tab })}
					>
						{translate(`agent.pages.widgets.tabs.${tab}`)}
					</Tabs>
				))}
			</ul>
		);
	}

	/** @returns {JSX.Element} */
	render() {
		return (
			<React.Fragment>
				<header className="w-fit mt-10 mb-6">
					<h1 className="hl-ms-6 mb-6">
						{translate('agent.pages.widgets.widgets')}
					</h1>

					{this.#renderTabs()}
				</header>

				{this.#renderWidget()}
			</React.Fragment>
		);
	}
}

export default ViewWidgets;
